export default "__VITE_ASSET__CiNOOzk1__"